export default __webpack_public_path__ + "static/media/Page_16.4cfaff6d.png";